module.exports = __webpack_public_path__ + "img/down-arrow1.413e3967.svg";